import { Outlet } from 'react-router-dom';

function SitesScene() {
  return <Outlet />;
}

export default SitesScene;
